import { render, staticRenderFns } from "./office.vue?vue&type=template&id=a8e9e5be&scoped=true&"
import script from "./office.vue?vue&type=script&lang=js&"
export * from "./office.vue?vue&type=script&lang=js&"
import style0 from "./office.vue?vue&type=style&index=0&id=a8e9e5be&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e9e5be",
  null
  
)

export default component.exports